import { render } from "./UpdateTimeframe.vue?vue&type=template&id=058dd8ee"
import script from "./UpdateTimeframe.vue?vue&type=script&lang=js"
export * from "./UpdateTimeframe.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/pages/UpdateTimeframe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "058dd8ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('058dd8ee', __exports__)) {
    api.reload('058dd8ee', __exports__)
  }
  
  module.hot.accept("./UpdateTimeframe.vue?vue&type=template&id=058dd8ee", () => {
    api.rerender('058dd8ee', render)
  })

}


export default __exports__